import React, { useEffect, useState } from 'react';
import TileTitle from './TileTitle';
import moment from 'moment';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';
import { useTranslation } from "react-i18next";

const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props;

    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-20)">{payload.value}</text>
        </g>
    );
}

const CustomTooltip = (props) => {
    const { t } = useTranslation();
    const { active } = props;

    if (active) {
        const { payload, label } = props;
        return (
            <div className="custom-tooltip">
                <p className="intro">{t("common.date") + ": " + label}</p>
                {payload[0] ?
                    <p className="desc">{t("common.value") + ": " + payload[0].value}</p>
                    :
                    <p className="desc">{t("common.noValue")}</p>
                }
            </div>
        );
    }

    return null;
}

const LineChartTile = ({ title, chartData, seriesPeriod, minYAxis, maxYAxis }) => {
    const { t } = useTranslation();


    const minY = Math.min(...chartData.values.map(item => item.value));
    const maxY = Math.max(...chartData.values.map(item => item.value));

    // Adjust the range slightly to ensure that the lines are not touching the axes
    const minYA = Math.round(minY - (0.1 * minY));
    const maxYA = Math.round(maxY + (0.1 * maxY));

    useEffect(() => {
        chartData.values.map((value) => {
            let format = "";
            if (seriesPeriod === "DAY") {
                format = "DD.MM";
            } else if (seriesPeriod === "MONTH") {
                format = "MM.YYYY";
            } else if (seriesPeriod === "YEAR") {
                format = "YYYY";
            }

            value.label = moment(new Date(value.date)).format(format);
        });
    }, [chartData, seriesPeriod]);

    const hasData = chartData.values.some(valueElement => valueElement.value !== null);

    return (
        <div className="tile tileWhite tileGraph">
            <TileTitle title={title} />
            {hasData ?
                <div className="tileContent">
                    <div>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={chartData.values}
                                margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
                                <XAxis dataKey="label" tick={<CustomizedAxisTick />} />
                                <YAxis domain={[minYA, maxYA]} />
                                <Tooltip content={<CustomTooltip />} />
                                <Line connectNulls={true}
                                    type="monotone"
                                    dataKey="value"
                                    stroke="#ffc402"
                                    activeDot={{ r: 8 }} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
                :
                <div className="tileContent">{t("admin.common.noData")}</div>
            }
        </div>
    )
}

export default LineChartTile;
